module.exports = __webpack_public_path__ + "static/img/Hawker-1.c3d76ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/Hawker-1.png
// module id = b75a
// module chunks = 0